var map = {
	"./app-window.svg": "c61b",
	"./approve-selected.svg": "e19a",
	"./approve.svg": "2378",
	"./arrow-right-red.svg": "3cac",
	"./arrow-right.svg": "30ad",
	"./bar-chart-selected.svg": "ff8a",
	"./bar-chart.svg": "ab6d",
	"./camera-circle.svg": "9638",
	"./camera.svg": "aea1",
	"./check-badge.svg": "5f61",
	"./copy.svg": "d4e7",
	"./decline-selected.svg": "9ebf",
	"./decline.svg": "1d91",
	"./export.svg": "0159",
	"./filter-black.svg": "01cd",
	"./filter-white.svg": "1386",
	"./filter.svg": "2ee9",
	"./folder-download.svg": "76c0",
	"./in-route.svg": "67af",
	"./line-chart-selected.svg": "294d",
	"./line-chart.svg": "68b8",
	"./menu.svg": "0f16",
	"./multiple.svg": "2a4c",
	"./pictures.svg": "42bf",
	"./print.svg": "cb2a",
	"./search-normal.svg": "45c0",
	"./search-status.svg": "f290",
	"./share.svg": "7345",
	"./shipment-search.svg": "c8f5",
	"./simple-marker.svg": "6a05",
	"./started-deliveries.svg": "f3d6",
	"./tick-square.svg": "a169",
	"./trash.svg": "096c",
	"./trend.svg": "a7f8",
	"./truck-location-cluster.svg": "fde1",
	"./truck-location.svg": "52ea",
	"./truck-performance-selected.svg": "1b38",
	"./truck-performance.svg": "77d8",
	"./truck.svg": "0e58",
	"./view-circle.svg": "ebaa",
	"./view.svg": "d95e",
	"./waiting-route.svg": "ac5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "627d1";